import { useLanguage } from '../context/LanguageContext';
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function CGV() {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <div className="max-w-4xl mx-auto px-4 md:px-6 py-6 md:py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-gray-500 hover:text-[#00aaff] mb-6 transition-colors">
          <ArrowLeft size={18} />
          <span className="text-sm">Retour à l'accueil</span>
        </Link>

        <h1 className="text-3xl md:text-5xl font-black text-gray-900 mb-8">Conditions Générales de Vente</h1>

        <div className="prose prose-gray max-w-none space-y-8">
          {/* Préambule */}
          <section>
            <p className="text-gray-700 leading-relaxed mb-4">
              Les présentes Conditions Générales de Vente (CGV) régissent les ventes de produits effectuées par la société <strong>Joey Cyan</strong> (SIRET : 830 404 588 00014) sur le site <strong>joeycyan.com</strong>.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Toute commande passée sur le site implique l'acceptation sans réserve des présentes CGV.
            </p>
          </section>

          {/* Article 1 */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Article 1 - Objet</h2>
            <p className="text-gray-700 leading-relaxed">
              Les présentes CGV ont pour objet de définir les droits et obligations des parties dans le cadre de la vente en ligne de lunettes connectées et accessoires proposés par Joey Cyan.
            </p>
          </section>

          {/* Article 2 */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Article 2 - Produits</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Les produits proposés à la vente sont les suivants :
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Lunettes connectées (optiques, solaires, caméra)</li>
              <li>Verres correcteurs et accessoires</li>
              <li>Étuis, câbles de charge et autres accessoires</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              Les produits sont décrits et présentés avec la plus grande exactitude possible. Toutefois, si des erreurs ou omissions ont pu se produire, la responsabilité de Joey Cyan ne pourrait être engagée.
            </p>
          </section>

          {/* Article 3 */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Article 3 - Prix</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Les prix de nos produits sont indiqués en euros toutes taxes comprises (TTC), hors frais de livraison.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Joey Cyan se réserve le droit de modifier ses prix à tout moment, étant toutefois entendu que le prix figurant au catalogue le jour de la commande sera le seul applicable à l'acheteur.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Les frais de livraison sont indiqués avant la validation finale de la commande.
            </p>
          </section>

          {/* Article 4 */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Article 4 - Commande</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Pour passer commande, le client doit :
            </p>
            <ol className="list-decimal list-inside space-y-2 text-gray-700 ml-4">
              <li>Créer un compte client ou se connecter</li>
              <li>Sélectionner les produits souhaités et les ajouter au panier</li>
              <li>Renseigner les informations de livraison et de facturation</li>
              <li>Choisir le mode de livraison</li>
              <li>Valider et procéder au paiement</li>
            </ol>
            <p className="text-gray-700 leading-relaxed mt-4">
              La validation de la commande vaut acceptation des présentes CGV et constitue une preuve du contrat de vente.
            </p>
          </section>

          {/* Article 5 */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Article 5 - Paiement</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Le paiement s'effectue en ligne par carte bancaire via notre solution de paiement sécurisé Stripe.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Les cartes acceptées sont : Visa, Mastercard, American Express.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Le débit de la carte bancaire est effectué au moment de la validation de la commande. En cas de refus de paiement, la commande est automatiquement annulée.
            </p>
          </section>

          {/* Article 6 */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Article 6 - Livraison</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Les produits sont livrés à l'adresse indiquée par le client lors de la commande.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>Délais de livraison :</strong> Les délais indicatifs sont de 3 à 7 jours ouvrés pour la France métropolitaine. Ces délais peuvent varier en fonction du transporteur et de la destination.
            </p>
            <p className="text-gray-700 leading-relaxed">
              En cas de retard de livraison supérieur à 30 jours, le client peut annuler sa commande et obtenir le remboursement intégral des sommes versées.
            </p>
          </section>

          {/* Article 7 */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Article 7 - Droit de rétractation</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Conformément à l'article L.221-18 du Code de la consommation, le client dispose d'un délai de <strong>14 jours</strong> à compter de la réception du produit pour exercer son droit de rétractation, sans avoir à justifier de motifs ni à payer de pénalités.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>⚠️ Important :</strong> Les frais de retour sont à la charge du client.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Pour exercer ce droit, le client doit nous notifier sa décision par email à : <strong>contact@joeycyan.com</strong>
            </p>
            <p className="text-gray-700 leading-relaxed">
              Le produit doit être retourné dans son emballage d'origine, en parfait état, complet (accessoires, notice, etc.). Le remboursement sera effectué dans un délai de 14 jours suivant la réception du produit retourné.
            </p>
            <p className="text-gray-700 leading-relaxed mt-4">
              Pour plus de détails, consultez notre <Link to="/politique-retour" className="text-[#00aaff] hover:underline">Politique de Retour</Link>.
            </p>
          </section>

          {/* Article 8 */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Article 8 - Garanties</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Tous nos produits bénéficient de la garantie légale de conformité (articles L.217-4 à L.217-14 du Code de la consommation) et de la garantie contre les vices cachés (articles 1641 à 1649 du Code civil).
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>Garantie légale de conformité :</strong> 2 ans à compter de la délivrance du bien.
            </p>
            <p className="text-gray-700 leading-relaxed">
              En cas de défaut de conformité, le client peut choisir entre la réparation ou le remplacement du produit, sous réserve des conditions prévues par la loi.
            </p>
          </section>

          {/* Article 9 */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Article 9 - Responsabilité</h2>
            <p className="text-gray-700 leading-relaxed">
              Joey Cyan ne saurait être tenue responsable de l'inexécution du contrat en cas de rupture de stock, indisponibilité du produit, force majeure, perturbation ou grève totale ou partielle des services postaux et moyens de transport.
            </p>
          </section>

          {/* Article 10 */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Article 10 - Données personnelles</h2>
            <p className="text-gray-700 leading-relaxed">
              Les données personnelles collectées lors de la commande font l'objet d'un traitement informatique destiné à la gestion des commandes et de la relation client.
            </p>
            <p className="text-gray-700 leading-relaxed mt-4">
              Pour plus d'informations, consultez notre <Link to="/politique-confidentialite" className="text-[#00aaff] hover:underline">Politique de Confidentialité</Link>.
            </p>
          </section>

          {/* Article 11 */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Article 11 - Litige et médiation</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Les présentes CGV sont soumises au droit français. Tout litige relatif à leur interprétation et/ou à leur exécution relève des tribunaux français.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Conformément à l'article L.612-1 du Code de la consommation, le client a la possibilité de recourir gratuitement à un médiateur de la consommation en vue de la résolution amiable du litige. Le médiateur peut être saisi en ligne sur la plateforme européenne de règlement en ligne des litiges : <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#00aaff] hover:underline">https://ec.europa.eu/consumers/odr/</a>
            </p>
          </section>

          {/* Contact */}
          <section className="bg-gray-50 p-6 rounded-xl">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Pour toute question relative aux présentes CGV ou à votre commande :
            </p>
            <ul className="list-none space-y-2 text-gray-700 ml-0">
              <li><strong>Joey Cyan</strong></li>
              <li>33 Avenue Philippe Auguste, 75011 Paris</li>
              <li>Email : contact@joeycyan.com</li>
              <li>SIRET : 830 404 588 00014</li>
            </ul>
          </section>
        </div>

        <p className="text-sm text-gray-400 mt-12">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>
      </div>
    </div>
  );
}
